/** Convert a currency amount to integer cents for safe comparisons. */
export const toCents = (amount: number): number => Math.round(Number(amount) * 100)

export const fromCents = (cents: number): number => cents / 100
